/* Native back-in-stock: shows when the selected variant is unavailable (or the
   whole product is sold out), lets the customer pick the size to watch, and
   subscribes their email to Klaviyo back-in-stock for that exact variant. */
(function () {
  function init() {
    var box = document.querySelector('.ss-nm');
    if (!box) return;
    var variants;
    try { variants = JSON.parse(box.querySelector('.ss-nm-variants').textContent); } catch (e) { return; }
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });
    var oos = variants.filter(function (v) { return !v.available; });
    if (!oos.length) return; // everything in stock, nothing to watch

    // size dropdown holds only the sold-out sizes (in-stock ones you just buy)
    var sizeSel = box.querySelector('.ss-nm-size');
    oos.forEach(function (v) {
      var o = document.createElement('option');
      o.value = String(v.id);
      o.textContent = v.title;
      sizeSel.appendChild(o);
    });
    if (oos.length === 1) sizeSel.value = String(oos[0].id);

    // Any size sold out -> the block is ALWAYS visible (the theme bounces the
    // selection off sold-out swatches, so show/hide toggling made it flicker).
    box.hidden = false;
    var note = box.querySelector('.ss-nm-note');
    if (note && oos.length < variants.length) note.hidden = false; // partial stock: add the short lead-in line

    function currentVariantId() {
      var el = document.querySelector('.product-form [name="id"], form[action*="/cart/add"] [name="id"]');
      return el && el.value ? String(el.value) : null;
    }
    function refresh() {
      var vid = currentVariantId();
      if (vid && byId[vid] && !byId[vid].available) sizeSel.value = vid; // follow the size they highlighted
    }
    refresh();
    setInterval(refresh, 700); // the theme swaps variants via its own JS; polling is the reliable hook
    document.addEventListener('change', function (e) { if (!box.contains(e.target)) refresh(); }, true);

    var openBtn = box.querySelector('.ss-nm-open');
    var panel = box.querySelector('.ss-nm-panel');
    openBtn.addEventListener('click', function () {
      var opening = panel.hidden;
      panel.hidden = !opening;
      openBtn.classList.toggle('ss-nm-openstate', opening);
      openBtn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      openBtn.querySelector('.ss-nm-caret').textContent = opening ? '▴' : '▾';
      if (opening) (sizeSel.value ? box.querySelector('.ss-nm-form input') : sizeSel).focus();
    });

    box.querySelector('.ss-nm-go').addEventListener('click', submit);
    box.querySelector('.ss-nm-form input').addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });

    function submit() {
      var input = box.querySelector('.ss-nm-form input');
      var email = input.value.trim();
      var err = box.querySelector('.ss-nm-err');
      err.hidden = true;
      if (!sizeSel.value) {
        err.textContent = 'Pick the size you want first.';
        err.hidden = false;
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        err.textContent = 'That email does not look right, check it and try again.';
        err.hidden = false;
        return;
      }
      var go = box.querySelector('.ss-nm-go');
      go.disabled = true; go.textContent = 'LOCKING IN…';
      function post() {
        return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + box.dataset.company, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + sizeSel.value } },
              },
            },
          }),
        });
      }
      // blocker-proof fallback: relays the signup through Google's servers,
      // which no ad blocker or tracking protection touches
      function relay() {
        return fetch('https://script.google.com/macros/s/AKfycbxu1kyjS4kTFvr0TAh4bWIPUKgKvym1oStvXPzQ9kjkKciuxz_Pq_dUfGstJ4a7pAeC/exec', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({ email: email, variantId: sizeSel.value }),
          redirect: 'follow',
        }).then(function (r) { return r.json(); }).then(function (j) {
          if (!j.ok) throw new Error('relay refused');
          return { ok: true };
        });
      }
      post().catch(relay)
        .then(function (r) {
          if (!r.ok) throw new Error('subscribe failed (' + r.status + ')');
          box.querySelector('.ss-nm-form').hidden = true;
          box.querySelector('.ss-nm-done').hidden = false;
        }).catch(function (e) {
          err.textContent = 'Could not lock it in. Try again in a minute, or email sales@stayshredded.com.au with your size and we will lock you in.';
          err.hidden = false;
        }).finally(function () {
          go.disabled = false; go.textContent = 'LOCK IT IN';
        });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
